import { addDays, endOfDay, isAfter, isBefore, parseISO } from "date-fns";

import { type ChatChannel, type ChatShiftStatus } from "../types";

export function getChatStatus(channel?: ChatChannel): ChatShiftStatus {
  if (!channel) {
    return "loading";
  }

  if (!channel.shift) {
    // if the feature flag is disabled or there's no metadata
    if (!channel.metadata?.lastBooked) {
      return "nothing";
    }

    return "past";
  }

  const start = parseISO(channel.shift.start);
  const end = parseISO(channel.shift.end);
  const now = new Date();

  const tomorrowEndOfDay = endOfDay(addDays(now, 1));
  const todayEndOfDay = endOfDay(now);

  if (isBefore(end, now)) {
    return "past";
  }

  if (isAfter(start, now)) {
    if (isBefore(start, todayEndOfDay)) {
      return "today";
    }

    if (isBefore(start, tomorrowEndOfDay)) {
      return "tomorrow";
    }

    return "ahead";
  }

  return "in progress";
}
